import { Component } from '@angular/core';

@Component({
	selector: 'q4sg-dashboard',
	templateUrl: './dashboard.component.html'
})
export class DashboardComponent { }
